module.exports = __webpack_public_path__ + "img/vertical_7_7_6005.500601cf.png";